import React from "react";

export default ({ selected, onSelectFilter }) => {
  let c = "btn ";
  return (
    <div className="col-100 toolbar-column btn-toolbar my-3">
      <div className="btn-group-toggle btn-group mr-2">
        <button
          className={
            c + (selected === "all" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("all")}
        >
          all time
        </button>
      </div>

      <div className="btn-group-toggle btn-group mr-2">
        <button
          className={
            c + (selected === "today" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("today")}
        >
          today
        </button>
      </div>
      <div className="btn-group btn-group-toggle mr-2">
        <button
          className={
            c +
            (selected === "this_week" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("this_week")}
        >
          this week
        </button>
        <button
          className={
            c +
            (selected === "last_week" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("last_week")}
        >
          last week
        </button>
      </div>
      <div className="btn-group btn-group-toggle mr-2 ">
        <button
          className={
            c +
            (selected === "this_month" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("this_month")}
        >
          this month
        </button>
        <button
          className={
            c +
            (selected === "last_month" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("last_month")}
        >
          last month
        </button>
      </div>
      <div className="btn-group btn-group-toggle mr-2">
        <button
          className={
            c +
            (selected === "this_year" ? "btn-primary" : "btn-outline-primary")
          }
          onClick={() => onSelectFilter("this_year")}
        >
          this year
        </button>
      </div>
    </div>
  );
};
